import * as React from 'react';

import type { PositioningClient } from '@/api/positioning-client';
import { HttpPositioningClient } from '@/api/positioning-client.http';

// =============================================================================
// positioning-client-context.tsx — Injection du PositioningClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S17) : l'adaptateur HTTP RÉEL
// (HttpPositioningClient) — le câblage front↔back contre le contrat de route figé D1. Les tests
// de composant injectent le StubPositioningClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultPositioningClient: PositioningClient = new HttpPositioningClient();

const PositioningClientContext =
  React.createContext<PositioningClient>(defaultPositioningClient);

export interface PositioningClientProviderProps {
  client?: PositioningClient | undefined;
  children: React.ReactNode;
}

export function PositioningClientProvider({
  client = defaultPositioningClient,
  children,
}: PositioningClientProviderProps): React.JSX.Element {
  return (
    <PositioningClientContext.Provider value={client}>
      {children}
    </PositioningClientContext.Provider>
  );
}

export function usePositioningClient(): PositioningClient {
  return React.useContext(PositioningClientContext);
}
